import React from "react"

import { StrategyPineDetailDialog } from "@/components/Strategies/StrategyPineDetailDialog"
import { Field, FieldContent, FieldDescription, FieldLabel, FieldTitle } from "@/components/ui/field"

import type { DashboardCardType, DashboardLayoutZone } from "../../../../types/dashboardLayout"
import { dashboardCardRegistry } from "../layout/dashboardCardRegistry"
import {
  DASHBOARD_LAYOUT_FIELD_DESC_CLASS,
  DASHBOARD_LAYOUT_FIELD_LABEL_CLASS,
} from "./dashboardLayoutUi"

export interface DashboardAddWidgetModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onCancel: () => void
  zone: DashboardLayoutZone | null
  selectableCards: DashboardCardType[]
  onSelectCard: (cardType: DashboardCardType) => void
}

const DashboardAddWidgetModal: React.FC<DashboardAddWidgetModalProps> = ({
  open,
  onOpenChange,
  onCancel,
  zone,
  selectableCards,
  onSelectCard,
}) => {
  const zoneTitle = zone === "miniStats" ? "Top Row Widgets" : "Lower Section Widgets"
  const zoneDescription =
    zone === "miniStats"
      ? "Top-row metrics use the dashboard date range above, except Return on Investment (all-time)."
      : "Choose a widget to add to this section."

  const handleSelect = (cardType: DashboardCardType) => {
    onSelectCard(cardType)
    onCancel()
  }

  return (
    <StrategyPineDetailDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onCancel()
        onOpenChange(nextOpen)
      }}
      title={zoneTitle}
      description={zoneDescription}
      showHeader
      dismissLabel="Close"
      contentClassName="sm:max-w-2xl"
      bodyClassName="flex-none overflow-visible"
      contentProps={{ "data-dashboard-add-widget-dialog": "" }}
    >
      <div data-dashboard-add-widget-picker="" className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {selectableCards.map((cardType) => (
          <FieldLabel
            key={cardType}
            role="button"
            tabIndex={0}
            className="has-data-checked:!border-transparent has-data-checked:!bg-transparent dark:has-data-checked:!border-transparent dark:has-data-checked:!bg-transparent"
            onClick={() => handleSelect(cardType)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault()
                handleSelect(cardType)
              }
            }}
          >
            <Field data-dashboard-add-widget-option="">
              <FieldContent>
                <FieldTitle className={DASHBOARD_LAYOUT_FIELD_LABEL_CLASS}>
                  {dashboardCardRegistry[cardType].title}
                </FieldTitle>
                <FieldDescription className={DASHBOARD_LAYOUT_FIELD_DESC_CLASS}>
                  Click to add widget
                </FieldDescription>
              </FieldContent>
            </Field>
          </FieldLabel>
        ))}
      </div>
    </StrategyPineDetailDialog>
  )
}

export default DashboardAddWidgetModal
